import * as svg from "../../../assets/paper-plane-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PaperPlaneIcon = iconBuilder(svg, "PaperPlaneIcon", "0 0 21 21");
